import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import NavBar from "../components/Navbar/NavBar";
import tag from "../images/tag.png";
import cer1 from "../images/cer1.png";
import cer2 from "../images/cer2.png";

const Certificate = () => {
  const { id } = useParams();
  const [petId, setID] = useState("");
  const [name, setName] = useState("");
  const [errors, setErrors] = useState(false);
  const [certificate, setCertificate] = useState(null);

  useEffect(() => {
    if (id) {
      fetchCertificate(id, "identity");
    }
  }, [id]);

  const fetchCertificate = async (id, type) => {
    try {
      const response = await axios.get(
        `https://api.wolftrainingchile.cl/certificates/cert/${id}/${type}`,
      );
      if (response.data) {
        setCertificate(response.data);
      } else {
        setErrors(true);
      }
    } catch (error) {
      console.error("Error fetching certificate:", error);
      setErrors(true);
    }
  };

  const clearErrors = () => {
    setErrors(false);
  };

  const sendEmail = (e) => {
    e.preventDefault();

    if (petId === "" || name === "") {
      return;
    }

    document.getElementById("submitBtn").disabled = true;
    document.getElementById("submitBtn").innerHTML = "Consultando...";

    const data = petId + "@" + name;
    setTimeout(async () => {
      let response = fetchCertificate(data, "certificate");
      if (response) {
        setCertificate(response.data);
      } else {
        setErrors(true);
        document.getElementById("submitBtn").disabled = false;
        document.getElementById("submitBtn").innerHTML = "Verificar";
      }
    }, 1400);
  };

  return (
    <>
      <div>
        <NavBar />
      </div>
      <div
        id="contact"
        className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24 "
      >
        <div
          className="container mx-auto my-8 px-4 lg:px-20"
          data-aos="zoom-in"
        >
          <form onSubmit={sendEmail}>
            <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-full lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
              <div className="flex">
                <h1 className=" text-2xl font-bold text-center lg:text-left text-orange-400 uppercase lg:text-4xl">
                  Validar certificado de adiestramiento
                </h1>
              </div>
              {!certificate && (
                <>
                  <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                    <div>
                      <label>Código certificado:</label>
                      <input
                        name="first_name"
                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                        type="text"
                        placeholder="Certificado*"
                        value={petId}
                        onChange={(e) => setID(e.target.value)}
                        onKeyUp={clearErrors}
                      />
                      {errors && (
                        <p className="text-red-500 text-sm">
                          {errors.first_name}
                        </p>
                      )}
                    </div>

                    <div>
                      <label>Nombre de la mascota:</label>
                      <input
                        name="last_name"
                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                        type="text"
                        placeholder="Nombre de la mascota*"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyUp={clearErrors}
                      />
                      {errors && (
                        <p className="text-red-500 text-sm">
                          {errors.last_name}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="my-2 w-1/2 lg:w-full mt-4">
                    <button
                      type="submit"
                      id="submitBtn"
                      className="uppercase text-sm font-bold tracking-wide bg-gray-800 hover:bg-orange-400 text-gray-100 p-3 rounded-lg w-full 
                                        focus:outline-none focus:shadow-outline"
                    >
                      Verificar
                    </button>
                    {errors && (
                      <div className="flex w-full justify-center mt-7">
                        <p className="text-red-500 text-sm lg:text-xl">
                          La información consultada no existe o no es valida.
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
              {certificate && (
                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                  <div className="lg:col-span-2 w-full flex justify-center">
                    <div
                      className={`w-[250px] h-[250px] bg-orange-200 bg-cover p-2`}
                    >
                      <img
                        src={certificate.pet.image}
                        alt="profile"
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </div>
                  <div>
                    <label>Código certificado:</label>
                    <input
                      name="identity"
                      className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="Identificador*"
                      disabled
                      value={certificate.customId}
                    />
                    {errors && (
                      <p className="text-red-500 text-sm">
                        {errors.first_name}
                      </p>
                    )}
                  </div>

                  <div>
                    <label>Nombre:</label>
                    <input
                      name="pet_name"
                      className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="Nombre de la mascota*"
                      value={certificate.pet.name.toUpperCase()}
                      disabled
                    />
                    {errors && (
                      <p className="text-red-500 text-sm">{errors.last_name}</p>
                    )}
                  </div>

                  <div>
                    <label>Raza:</label>
                    <input
                      name="raza"
                      className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="Raza*"
                      value={certificate.pet.breed.name.toUpperCase()}
                      disabled
                    />
                    {errors && (
                      <p className="text-red-500 text-sm">
                        {errors.first_name}
                      </p>
                    )}
                  </div>

                  <div>
                    <label>Genero:</label>
                    <input
                      name="gender"
                      className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="Genero*"
                      value={certificate.pet.gender}
                      disabled
                    />
                    {errors && (
                      <p className="text-red-500 text-sm">{errors.last_name}</p>
                    )}
                  </div>

                  <div>
                    <label>Número de chip:</label>
                    <input
                      name="raza"
                      className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="Raza*"
                      value={certificate.pet.chip}
                      disabled
                    />
                    {errors && (
                      <p className="text-red-500 text-sm">
                        {errors.first_name}
                      </p>
                    )}
                  </div>

                  <div>
                    <label>Adiestrado para:</label>
                    <input
                      name="gender"
                      className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="Genero*"
                      value={
                        certificate.adi ? certificate.adi : "ALERTA MEDICA"
                      }
                      disabled
                    />
                    {errors && (
                      <p className="text-red-500 text-sm">{errors.last_name}</p>
                    )}
                  </div>
                  <div className="lg:col-span-2">
                    <label>Observación:</label>
                    <input
                      name="gender"
                      className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="Genero*"
                      value={
                        certificate.obs ? certificate.obs : "Alerta medica"
                      }
                      disabled
                    />
                    {errors && (
                      <p className="text-red-500 text-sm">{errors.last_name}</p>
                    )}
                  </div>
                  <div className="lg:col-span-2 w-full flex flex-col lg:flex-row">
                    <img alt="Valido" src={tag} className="h-[65px] lg:pr-4" />
                    <div className="flex flex-row justify-center">
                      <img
                        src={cer1}
                        className="h-[80px] w-[80px]"
                        alt="assistance dogs"
                      />
                      <img
                        src={cer2}
                        className="h-[80px] w-[80px]"
                        alt="dogs"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Certificate;
